import React from "react";

const SvgStream = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.21207 3.37143L7.14286 2V5.42857L5.21207 4.05714V5.42857H2V2H5.21207V3.37143ZM8.28571 2H10V3.14286V8.85714V10H8.85714H3.14286H2V6.57143H3.14286V8.85714H8.85714V3.14286H8.28571V2Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgStream;
